<script lang="ts">
    import { getFavoriteTranslationsCardsets } from "@app/services/flashcards.service";
    import { getCardsetCover } from "../cardsetUtils";
    import {
        COMMON__Cards_count,
        COMMON__My_favorite_translations,
    } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import {
        homeBreadcrumbItem,
        myFavoriteTranslationsBreadcrumbItem,
        myGlosbeBreadcrumbItem,
        setBreadcrumbs,
    } from "@app/components/Breadcrumbs/breadcrumbs.store";

    const cardsetsPromise = getFavoriteTranslationsCardsets();
    setBreadcrumbs([
        homeBreadcrumbItem(),
        myGlosbeBreadcrumbItem(),
        myFavoriteTranslationsBreadcrumbItem(),
    ]);
</script>

<svelte:head>
    <title>{getMessage(COMMON__My_favorite_translations)} | Glosbe</title>
</svelte:head>

{#await cardsetsPromise then cardsets}
    <div class=" max-w-4xl m-auto p-2">
        <h1 class="text-xl md:text-2xl mb-6 font-medium">
            {getMessage(COMMON__My_favorite_translations)}
        </h1>
        <ul class="grid sm:grid-cols-2 gap-2">
            {#each cardsets as cardset, index}
                <li class="">
                    <div
                        class="flex w-full flex-col items-center cardsetCover hover:ring-4 hover:ring-tertiary-300 transition-all duration-300 rounded shadow bg-white"
                    >
                        <a
                            href={`?l1=${cardset.languageCode1}&l2=${cardset.languageCode2}`}
                            class="p-2 block w-full flex gap-2"
                        >
                            <div
                                class={`rounded-lg h-24 w-24 relative bg-no-repeat bg-cover ${
                                    getCardsetCover(cardset, index).background
                                } border border-slate-300`}
                            >
                                <img
                                    src={getCardsetCover(cardset, index)
                                        .coverUrl}
                                    class="w-full h-full object-contain rounded-md"
                                    alt="Cardset {cardset.title} cover"
                                />
                            </div>
                            <div class="flex flex-col flex-1">
                                <h5 class="text-lg font-medium">
                                    {cardset.title}
                                </h5>
                                <p class="text-slate-800 text-base">
                                    {cardset.languageCode1 || ""}
                                    {cardset.languageCode2 || ""}
                                </p>
                                <p class="text-slate-600 text-sm">
                                    {getMessage(COMMON__Cards_count, [
                                        cardset.cardsSize + "",
                                    ])}
                                </p>
                            </div>
                        </a>
                    </div>
                </li>
            {/each}
        </ul>
    </div>
{/await}
